import React from 'react';
import { Link } from 'react-scroll';
import { FiTarget, FiAward, FiUsers, FiBriefcase } from 'react-icons/fi';
import Reveal from '../fx/Reveal';
import Counter from '../fx/Counter';

const stats = [
    { icon: <FiTarget />, value: 15, suffix: '+', label: 'Training Sessions' },
    { icon: <FiAward />, value: 9, suffix: '+', label: 'CTF Events Organized' },
    { icon: <FiUsers />, value: 700, suffix: '+', label: 'Students Trained' },
    { icon: <FiBriefcase />, value: 10, suffix: '+', label: 'Corporate Clients' },
];

const About = () => {
    return (
        <section id="about" className="relative bg-[#05060a] text-white px-6 md:px-16 py-24 overflow-hidden">
            <div className="absolute -right-40 top-10 w-[600px] h-[600px] rounded-full bg-red-700/10 blur-3xl pointer-events-none" />
            <div className="relative max-w-7xl mx-auto grid md:grid-cols-2 gap-14 items-center">
                <Reveal>
                    <span className="pill tag inline-flex mb-4">ABOUT</span>
                    <h2 className="font-display text-4xl md:text-5xl font-bold mb-5 leading-tight">
                        Built by practitioners, <br />
                        for <span className="text-gradient-red">Indonesia</span>.
                    </h2>
                    <p className="text-gray-300 mb-4 leading-relaxed">
                        SiberLab ID was founded with a mission to strengthen Indonesia's
                        cybersecurity posture through education, training, and professional services.
                    </p>
                    <p className="text-gray-400 mb-4 leading-relaxed">
                        We believe cybersecurity knowledge should be accessible to all, which is why
                        we created Akademi Siber, a platform that delivers high-quality cybersecurity
                        education in Bahasa Indonesia at student-friendly prices.
                    </p>
                    <p className="text-gray-400 mb-8 leading-relaxed">
                        Our team consists of experienced professionals who have helped organizations
                        of every size secure their digital assets and uplift their security teams.
                    </p>
                    <Link to="contact" smooth duration={600} offset={-40} className="btn-primary cursor-pointer">
                        Talk to a specialist
                    </Link>
                </Reveal>

                <div className="grid grid-cols-2 gap-5">
                    {stats.map((stat, idx) => (
                        <Reveal key={idx} delay={idx * 100}>
                            <div className="card p-6 h-full">
                                <div className="text-red-400 mb-3">{stat.icon}</div>
                                <div className="font-display text-4xl font-bold text-gradient-red leading-none">
                                    <Counter to={stat.value} suffix={stat.suffix} />
                                </div>
                                <div className="text-gray-400 mt-3 text-sm font-mono uppercase tracking-wider">
                                    {stat.label}
                                </div>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default About;
